import logo from './logo.svg';
import './App.css';
import { RouterProvider } from 'react-router';
import { BrowserRouter, createBrowserRouter, useFetcher } from 'react-router-dom';
import QuestionPage from './pages/questionPage/QuestionPage';
import No from './pages/noPage/No';
import Yes from './pages/yesPage/Yes';
import CdPortal from './pages/portal/countDownPortal/CdPortal';


function App() {
    const music = new Audio("audio/style.mp3");

    const router = createBrowserRouter  ([
      {
        path: "/",
        element: <QuestionPage/>,
      },
      {
        path: "/sheSaidNo",
        element: <No/>,
      },
      {
        path: "/sheSaidYes",
        element: <Yes music={music}/>,
      },
      {
        path: "/portal",
        element: <CdPortal/>,
      }

    ]);
  
    return (
      <div className="App">
        <RouterProvider router={router} />
      </div>
    );
  }
  
  export default App;
